import IconArrow from "assets/icons/Arrow";
import classNames from "classnames";
import React from "react";
import { Link } from "react-router-dom";
import styles from "./styles.module.scss";

interface BaseProps {
  children?: React.ReactNode;
  className?: string;
  iconClassName?: string;
  type?: "link" | "primary" | "secondary" | "light";
}

interface ButtonProps {
  disabled?: boolean;
  isSubmit?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  showArrowIcon?: boolean;
}

interface LinkProps {
  href?: string;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
  showNewWindowIcon?: boolean;
  target?: React.HTMLAttributeAnchorTarget;
}

export type Props = BaseProps & (ButtonProps | LinkProps);

const Button: React.FC<Props> = ({
  children,
  className,
  iconClassName,
  type,
  ...props
}) => {
  if ((props as LinkProps).href) {
    const { href, onClick, showNewWindowIcon, target } = props as LinkProps;

    return (
      <Link
        className={classNames(
          styles.button,
          {
            [styles.link]: type === "link",
            [styles.primary]: type === "primary",
            [styles.secondary]: type === "secondary",
            [styles.light]: type === "light",
          },
          className
        )}
        onClick={onClick}
        target={target}
        to={href || ""}
      >
        {children}

        {showNewWindowIcon && (
          <IconArrow
            type="square-top-right"
            className={classNames(styles.icon, iconClassName)}
          />
        )}
      </Link>
    );
  }

  const { disabled, isSubmit, onClick, showArrowIcon } = props as ButtonProps;

  return (
    <button
      className={classNames(
        styles.button,
        {
          [styles.link]: type === "link",
          [styles.primary]: type === "primary",
          [styles.secondary]: type === "secondary",
          [styles.light]: type === "light",
        },
        className
      )}
      disabled={disabled}
      onClick={onClick}
      type={isSubmit ? "submit" : "button"}
    >
      {children}
      {showArrowIcon && (
        <IconArrow
          className={classNames(styles.icon, iconClassName)}
          type="right"
        />
      )}
    </button>
  );
};

export default Button;
